import * as t from "io-ts";
import { isLeft } from "fp-ts/lib/Either";
import defensiveCopy from "@/util/defensive-copy";

const EmptyArrayOrAny = new t.Type<unknown, unknown, unknown>(
  "EmptyArrayOrAny",
  (_): _ is unknown => true,
  (input, context) => {
    if (Array.isArray(input) && input.length === 0) {
      return t.failure(input, context);
    }
    return t.success(input);
  },
  t.identity
);

const EmptyArrayBorderV = t.partial({
  top: EmptyArrayOrAny,
  bottom: EmptyArrayOrAny,
  left: EmptyArrayOrAny,
  right: EmptyArrayOrAny
});

export type EmptyArrayBorder = t.TypeOf<typeof EmptyArrayBorderV>;

export function doesBorderContainEmptyArray(border: unknown) {
  const result = EmptyArrayBorderV.decode(border);
  return isLeft(result);
}

export function transformEmptyArrayToObject(border: EmptyArrayBorder) {
  const newBorder = defensiveCopy(border);
  const sides = ["top", "bottom", "left", "right"] as const;

  for (const side of sides) {
    if (
      Array.isArray(newBorder[side]) &&
      (newBorder[side] as Array<any>).length === 0
    ) {
      newBorder[side] = {
        width: null,
        color: "",
        style: ""
      };
    }
  }

  return newBorder;
}
